import './StickyActionTable.scss';
import React, { FunctionComponent, memo } from 'react';
import { Table } from 'plume-ui';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { TableProps } from 'plume-ui/src/components/Table/Table';

const StickyActionTable: FunctionComponent<TableProps> = ({ ...props }) => {
  return (
    <PerfectScrollbar
      className="StickyActionTable__scrollbar"
      style={{ maxWidth: '100%' }}
    >
      <Table
        {...props}
        classes={(current) => ({
          ...current,
          cell: `${current.cell} StickyActionTable__cell`,
          heading: `${current.heading} StickyActionTable__heading`,
          dataRow: `${current.dataRow} StickyActionTable__row`,
          headerRow: `${current.headerRow} StickyActionTable__headerRow`,
        })}
      />
    </PerfectScrollbar>
  );
};

export default memo(StickyActionTable);
